import { apiClient } from './apiClient';

export interface VesselFinderStatus {
  remaining_credits: number;
  expiration_date: string;
  status: string;
}

export const VesselFinderStatusService = {
  async getStatus(): Promise<VesselFinderStatus> {
    return apiClient.get<VesselFinderStatus>('/admin/vesselfinder/status');
  },
};
